<it-card teaser="true" shadow="true" *ngIf="forms?.length">
  <div class="row mt-2">
    <div class="col">
      <div class="mb-3">
        <it-select label="Modulo" [(ngModel)]="selectedFormCode">
          <option [ngValue]="null">Seleziona tipologia di modulo</option>
          <option *ngFor="let form of uniqueForms" [value]="form.formType.code">
            {{ form.name }}
          </option>
        </it-select>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">
          Torna indietro
        </button>
        <button
          itButton="primary"
          type="button"
          [disabled]="!selectedFormCode"
          (click)="confirm()"
        >
          Aggiungi modulo
        </button>
      </div>
    </div>
  </div>
</it-card>
